import { resolvePaymentFailureReasonKey } from '@/components/payouts/payoutPaymentFailureReason';
import { Text, VStack } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface PaymentNotChargedNoticeProps {
  /** The provider's reason for the refusal, null when it gave none. */
  failureCode: string | null;
}

/**
 * The first thing a brand needs after a refused payment: their money never left.
 */
const PaymentNotChargedNotice: React.FC<PaymentNotChargedNoticeProps> = ({ failureCode }) => {
  const { t } = useTranslation();

  return (
    <VStack align="start" gap={1}>
      <Text fontWeight="medium">{t('payouts.failure.notCharged')}</Text>
      <Text color="fg.muted" fontSize="sm">
        {t(resolvePaymentFailureReasonKey(failureCode))}
      </Text>
    </VStack>
  );
};

export default PaymentNotChargedNotice;
